import { useState } from "react"
import logoMarkUrl from "../assets/logo-mark.svg"
import { Link } from "./link"

export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false)
  const closeMenu = () => setMenuOpen(false)

  return (
    <header className={menuOpen ? "site-header site-header--menu-open" : "site-header"}>
      <Link href="/" className="brand-mark">
        <img src={logoMarkUrl} alt="" className="brand-mark__icon" aria-hidden="true" />
        <span>Adgiro</span>
      </Link>
      <button
        type="button"
        className="site-menu-button"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        aria-controls="site-navigation"
        onClick={() => setMenuOpen((isOpen) => !isOpen)}
      >
        <span className="site-menu-button__line site-menu-button__line--top" />
        <span className="site-menu-button__line site-menu-button__line--middle" />
        <span className="site-menu-button__line site-menu-button__line--bottom" />
      </button>
      <nav id="site-navigation" className={menuOpen ? "top-nav is-open" : "top-nav"}>
        <Link href="/docs" onClick={closeMenu}>
          Docs
        </Link>
        <Link href="/pricing" onClick={closeMenu}>
          Pricing
        </Link>
        <Link href="/privacy" onClick={closeMenu}>
          Privacy
        </Link>
        <Link href="/terms" onClick={closeMenu}>
          Terms
        </Link>
        <Link href="/login" className="button button--ghost" onClick={closeMenu}>
          Log in
        </Link>
      </nav>
    </header>
  )
}
